@if (!error) {
  <button
    mat-menu-item
    (click)="confirmDelete()"
  >
    <span>
      {{ 'TRANS__DELETE_ITEM__DELETE' | translate }}
    </span>
  </button>
}
